import React from "react";
import { useTranslation } from "react-i18next";

import Checkbox from "../../../components/FormElement/Checkbox";
import { AVAILABLE_LANGUAGES } from "../../../models/LocationReviewRequestPrints";

import "./styles.scss";

interface EditLanguagesModalProps {
  isOpen: boolean;
  onClose: () => void;
  selectedLanguages: string[];
  onSave: (languages: string[]) => void;
  sizeName: string;
}

export const EditLanguagesModal: React.FC<EditLanguagesModalProps> = ({
  isOpen,
  onClose,
  selectedLanguages,
  onSave,
  sizeName,
}) => {
  const { t: _t } = useTranslation();
  const t = (key: string) => _t(`reviewRequestPrintsPage.${key}`);

  const [localSelected, setLocalSelected] =
    React.useState<string[]>(selectedLanguages);

  React.useEffect(() => {
    setLocalSelected(selectedLanguages);
  }, [selectedLanguages, isOpen]);

  if (!isOpen) return null;

  const handleToggle = (langCode: string) => {
    setLocalSelected((prev) => {
      if (prev.includes(langCode)) {
        return prev.filter((code) => code !== langCode);
      } else {
        return [...prev, langCode];
      }
    });
  };

  const handleUncheckAll = () => {
    setLocalSelected([]);
  };

  const handleSave = () => {
    onSave(localSelected);
    onClose();
  };

  return (
    <div className="modal modal-default edit-languages-modal">
      <div className="modal-mains">
        <div className="btn-close" onClick={onClose}></div>
        <h2 className="title">
          {t("edit_languages_title")} - {sizeName}
        </h2>
        <div className="modal-content">
          <div className="language-checkboxes">
            {AVAILABLE_LANGUAGES.map((lang) => {
              return (
                <Checkbox
                  key={lang.code}
                  id={`edit-lang-${lang.code}`}
                  label={lang.label}
                  checked={localSelected.includes(lang.code)}
                  onChange={() => handleToggle(lang.code)}
                />
              );
            })}
          </div>
        </div>
        <div className="bottom-btns">
          <button className="btn btn-border" onClick={handleUncheckAll}>
            {t("uncheck_all")}
          </button>
          <button className="btn btn-border" onClick={onClose}>
            {t("cancel")}
          </button>
          <button className="btn btn-blue" onClick={handleSave}>
            {t("save")}
          </button>
        </div>
      </div>
    </div>
  );
};
